module.exports = __webpack_public_path__ + "static/media/canada10.0c3088a9.jpg";